<template>
  <div
    class="margin-top-s"
    data-section="pricing-policy"
    data-auto="pricing-policy"
  >
    <label
      class="label"
      :class="{'loyallist-header' : !isMcom && badge.isLoyallistOffer}"
    > {{ isMcom? badge.header : bcomBadgeData.header }} </label>
    <p class="regular margin-top-xs">
      {{ isMcom? badge.checkoutDescription : bcomBadgeData.subHeader }}
    </p>

    <button
      v-show="!showViewMore && badge?.legalDisclaimer"
      ref="viewMore"
      class="view-more-button link-sm margin-bottom-m"
      :aria-expanded="showViewMore"
      @click="toggleView"
    >
      View More
    </button>

    <template v-if="showViewMore && badge?.legalDisclaimer">
      <p
        class="regular margin-top-xs"
        data-el="product-dimensions"
      >
        {{ badge.legalDisclaimer }}
      </p>
    </template>
    <button
      v-show="showViewMore && badge?.legalDisclaimer"
      ref="viewLess"
      class="view-less-button link-sm margin-bottom-m"
      :aria-expanded="showViewMore"
      :aria-label="`View Less, button. Expanded content: ${badge.legalDisclaimer}`"
      @click="toggleView"
    >
      View Less
    </button>

    <template v-if="!badge?.legalDisclaimer">
      <div class="margin-bottom-m" />
    </template>
  </div>

  <hr class="divider gray-background expanded margin-top-z margin-bottom-z">
</template>

<script setup>
import { ref, nextTick } from 'vue';
import { brand } from 'config';

const props = defineProps({
  badge: {
    /** @type import('vue').PropType<Badge> */
    type: Object,
    required: true,
  },
});

const isMcom = brand === 'mcom';
const isBcomLoyallist = !isMcom && props.badge.isLoyallistOffer;
const bcomBadgeData = {
  header: isBcomLoyallist ? props.badge.title : props.badge.description,
  subHeader: isBcomLoyallist ? props.badge.description : props.badge.checkoutDescription,
};

const showViewMore = ref(false);
const viewMore = ref(null);
const viewLess = ref(null);

const toggleView = () => {
  showViewMore.value = !showViewMore.value;
  nextTick(() => {
    if (!showViewMore.value) viewMore.value?.focus();
    else viewLess.value?.focus();
  });
};
</script>

<style brand="bcom" scoped>
@import "~settingSCSS";

.loyallist-header {
  color: $loyalty-1-color;
}
</style>
